<po-page-list
  p-title="Engpro JB - Regras">

  <div class="po-row">

    <po-button
      class="po-lg-3 po-mt-3"
      p-kind="primary"
      (p-click)="criajamesrule.open()"
      p-label="Cadastrar regra" >
    </po-button>

    <po-button
      class="po-lg-3 po-mt-3"
      (p-click)="getJamesB()"
      p-label="Atualizar"
      p-icon="po-icon-refresh">
    </po-button>

  </div>

  <po-divider></po-divider>

  <po-container class="po-lg-12">
    <po-table
          p-height="500"
          p-actions-right="false"
          [p-columns]="jamesBColumns"
          [p-items]="jamesBItem"
          [p-striped]="true"
          [p-actions]="ruleActions"
          p-sort="true">

          <ng-template
            p-table-row-template
            let-rowItem
            let-i="rowIndex"
            [p-table-row-template-arrow-direction]="'left'"
          >
            <po-list-view
              p-property-title="name"
              class="list-no-margin"
              [p-items]="rowItem.details"
            >
              <ng-template p-list-view-content-template let-item>
                <div class="po-row" *ngIf="['AppServer', 'DbAccess', 'WebApp'].includes(item.type)">
                  <po-switch class="po-md-1 po-lg-1 force-info" p-size="small" [(ngModel)]="item.valid" (p-change)="changeValid(item, rowItem)" p-label="Válido?" p-label-off="Não" p-label-on="Sim"></po-switch>
                  <po-tag    class="po-md-1 po-lg-1" *ngIf="item.type === 'AppServer'" [p-orientation]="vertical" p-color="color-08" [p-value]="item.type"></po-tag>
                  <po-tag    class="po-md-1 po-lg-1" *ngIf="item.type === 'DbAccess'" [p-orientation]="vertical" p-color="color-09" [p-value]="item.type"></po-tag>
                  <po-tag    class="po-md-1 po-lg-1" *ngIf="item.type === 'WebApp'" [p-orientation]="vertical" p-color="color-10" [p-value]="item.type"></po-tag>
                  <po-info   class="po-md-1 po-lg-1" [p-value]="item.build" p-label="Build"></po-info>
                  <po-info   class="po-md-1 po-lg-2" [p-value]="wrapText(item.description, 55)" p-label="Descrição"></po-info>
                  <po-info   class="po-md-1 po-lg-1" [p-value]="item.version" p-label="Versão"></po-info>
                  <div class="po-md-1 po-lg-1">
                    <po-button p-label="Editar" p-icon="po-icon-edit" (p-click)="addAppDBOpen(rowItem, false, item)"></po-button>
                    <po-button p-label="Excluir" p-icon="po-icon-delete" (p-click)="deleteComponent(item, rowItem)" p-danger="true"></po-button>
                  </div>
                </div>
                <div class="po-row" *ngIf="item.type === 'IniKeys'">
                  <po-switch class="po-md-1 po-lg-1 force-info" p-size="small" [(ngModel)]="item.valid" (p-change)="changeValid(item, rowItem)" p-label="Válido?" p-label-off="Não" p-label-on="Sim"></po-switch>
                  <po-tag    class="po-md-1 po-lg-1" [p-orientation]="vertical" p-color="color-12" [p-value]="item.type"></po-tag>
                  <po-info   class="po-md-1 po-lg-2" p-value="[{{item.group}}] {{item.key}}={{item.value}}" p-label="Ini Key"></po-info>
                  <po-info   class="po-md-1 po-lg-2" [p-value]="wrapText(item.description, 55)" p-label="Descrição"></po-info>
                  <div class="po-md-1 po-lg-1">
                    <po-button p-label="Editar" p-icon="po-icon-edit" (p-click)="addAppDBOpen(rowItem, false, item)"></po-button>
                    <po-button p-label="Excluir" p-icon="po-icon-delete" (p-click)="deleteComponent(item, rowItem)" p-danger="true"></po-button>
                  </div>
                </div>
              </ng-template>
            </po-list-view>
          </ng-template>
    </po-table>
  </po-container>

  <div class="sample-container" *ngIf="loading">
    <po-loading-overlay></po-loading-overlay>
  </div>

</po-page-list>


<po-modal #criajamesrule
    p-title="Nova Regra"
    [p-primary-action]="confirm"
    [p-secondary-action]="close">

    <po-dynamic-form
      #dynamicForm
      p-auto-focus="rule"
      [p-fields]="rule_fields"
      [p-load]="onLoadFields.bind(this)"
      [p-validate]="this.onChangeFields.bind(this)"
      [p-value]="newrule"
    >
    </po-dynamic-form>


</po-modal>

<po-modal #AppDB
    [p-title]="__componentActionAdd ? 'Novo Artefato' : 'Editar Artefato'"
    [p-primary-action]="__componentActionAdd ? addComponent : editComponent"
    [p-secondary-action]="closeComponent">

    <div class="po-row" *ngIf="__componentActionAdd">
      <po-select
        class="po-lg-6"
        name="component"
        p-label="Componente"
        [p-options]="componentList"
        [(ngModel)]="__componente">
      </po-select>
    </div>

    <div class="po-row" *ngIf="__componente === 'inikeys'">
      <po-input
        class="po-md-5"
        name="appGroup"
        p-clean
        p-label="Grupo"
        [(ngModel)]="__group">
      </po-input>
    </div>

    <div class="po-row" *ngIf="__componente === 'inikeys'">
      <po-input
        class="po-md-5"
        name="appKey"
        p-clean
        p-label="Chave"
        [(ngModel)]="__key">
      </po-input>
    </div>

    <div class="po-row" *ngIf="__componente === 'inikeys'">
      <po-input
        class="po-md-5"
        name="appValue"
        p-clean
        p-label="Valor"
        [(ngModel)]="__value">
      </po-input>
    </div>

    <div class="po-row" *ngIf="__componente !== 'inikeys'">
      <po-input
        class="po-md-5"
        name="appBuild"
        p-clean
        p-label="Build"
        [(ngModel)]="__build">
      </po-input>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-8"
        name="appDescription"
        p-clean
        p-label="Descrição"
        [(ngModel)]="__description">
      </po-input>
    </div>

    <div class="po-row" *ngIf="__componente !== 'inikeys'">
      <po-input
        class="po-md-5"
        name="appVersion"
        p-clean
        p-label="Versão"
        [(ngModel)]="__version">
      </po-input>
    </div>

    <div class="po-row">
      <po-switch
          p-label="Ativar?"
          name="appAvailable"
          class="po-lg-6"
          [(ngModel)]="__valid"
          p-label-off="Não"
          p-label-on="Sim">
      </po-switch>
    </div>

</po-modal>

<po-modal #EditRule
    p-title="Editar"
    [p-primary-action]="editRule"
    [p-secondary-action]="closeRuleEdit">

    <po-dynamic-form
      #dynamicForm
      p-auto-focus="rule"
      [p-fields]="rule_fields"
      [p-load]="onLoadFields.bind(this)"
      [p-validate]="this.onChangeFields.bind(this)"
      [(p-value)]="newrule"
    >
    </po-dynamic-form>

</po-modal>
